export interface ModalResult {
    cancelled: boolean;
    value?: any;
}

export class ModalManager {
    static showTryAgainModal(onCurrentModel: () => void, onDifferentModel: () => void): void {
        const modal = document.createElement('div');
        modal.className = 'modal-overlay';
        modal.innerHTML = `
            <div class="modal">
                <div class="modal-header">
                    <h3>Regenerate Response</h3>
                    <button class="modal-close">&times;</button>
                </div>
                <div class="modal-body">
                    <p>Choose how to regenerate the response:</p>
                    <div class="try-again-options">
                        <button class="try-again-btn" data-option="current">
                            <i class="option-icon" data-lucide="rotate-ccw"></i>
                            <span>Try again with current model</span>
                        </button>
                        <button class="try-again-btn" data-option="different">
                            <i class="option-icon" data-lucide="refresh-cw"></i>
                            <span>Choose different model</span>
                        </button>
                    </div>
                </div>
            </div>
        `;

        document.body.appendChild(modal);
        (window as any).lucide?.createIcons();

        const closeModal = () => modal.remove();

        modal.querySelector('.modal-close')?.addEventListener('click', closeModal);
        modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

        modal.querySelector('[data-option="current"]')?.addEventListener('click', () => {
            closeModal();
            onCurrentModel();
        });

        modal.querySelector('[data-option="different"]')?.addEventListener('click', () => {
            closeModal();
            onDifferentModel();
        });
    }

    static showLightbox(images: string[], startIndex: number): void {
        const lightbox = document.createElement('div');
        lightbox.className = 'image-lightbox';
        lightbox.innerHTML = `
            <button class="lightbox-close">&times;</button>
            <button class="lightbox-nav prev" ${startIndex === 0 ? 'disabled' : ''}>&#10094;</button>
            <img src="${images[startIndex]}" alt="Image ${startIndex + 1}">
            <button class="lightbox-nav next" ${startIndex === images.length - 1 ? 'disabled' : ''}>&#10095;</button>
            <div class="lightbox-counter">${startIndex + 1} / ${images.length}</div>
            <button class="lightbox-download" title="Download">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
            </button>
        `;

        document.body.appendChild(lightbox);
        document.body.style.overflow = 'hidden';

        const lightboxImg = lightbox.querySelector('img') as HTMLImageElement;
        const prevBtn = lightbox.querySelector('.lightbox-nav.prev') as HTMLButtonElement;
        const nextBtn = lightbox.querySelector('.lightbox-nav.next') as HTMLButtonElement;
        const closeBtn = lightbox.querySelector('.lightbox-close') as HTMLButtonElement;
        const counter = lightbox.querySelector('.lightbox-counter') as HTMLDivElement;
        const downloadBtn = lightbox.querySelector('.lightbox-download') as HTMLButtonElement;

        let currentIdx = startIndex;

        const updateImage = (idx: number) => {
            lightboxImg.src = images[idx];
            counter.textContent = `${idx + 1} / ${images.length}`;
            prevBtn.disabled = idx === 0;
            nextBtn.disabled = idx === images.length - 1;
            prevBtn.style.opacity = idx === 0 ? '0.3' : '1';
            nextBtn.style.opacity = idx === images.length - 1 ? '0.3' : '1';
        };

        const closeLightbox = () => {
            document.removeEventListener('keydown', handleKeydown);
            lightbox.style.opacity = '0';
            setTimeout(() => {
                lightbox.remove();
                document.body.style.overflow = '';
            }, 200);
        };

        const handleKeydown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') closeLightbox();
            else if (e.key === 'ArrowLeft' && currentIdx > 0) { currentIdx--; updateImage(currentIdx); }
            else if (e.key === 'ArrowRight' && currentIdx < images.length - 1) { currentIdx++; updateImage(currentIdx); }
        };

        closeBtn.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });

        prevBtn.addEventListener('click', () => { if (currentIdx > 0) { currentIdx--; updateImage(currentIdx); }});
        nextBtn.addEventListener('click', () => { if (currentIdx < images.length - 1) { currentIdx++; updateImage(currentIdx); }});

        downloadBtn.addEventListener('click', () => {
            const link = document.createElement('a');
            link.href = images[currentIdx];
            link.download = `image-${currentIdx + 1}.png`;
            link.click();
        });

        document.addEventListener('keydown', handleKeydown);
    }

    static showConfirmDialog(message: string): Promise<boolean> {
        return new Promise((resolve) => {
            const confirmed = window.confirm(message);
            resolve(confirmed);
        });
    }
}